document.addEventListener("DOMContentLoaded", () => {
    const product = JSON.parse(document.querySelector("script[data-custom-product]")?.textContent || '{}');
    const same_products = JSON.parse(document.querySelector("script[data-same-product]")?.textContent || '{"products":[]}');
    const products = same_products.products || [];

    console.log("Product:", product);
    console.log("Same products:", same_products);

    const custom_variant_content = document.querySelector(".custom-variant-selector-content");
    const right_selectors = custom_variant_content?.querySelectorAll(".right-eye-variant-selector select[data-type='option']");
    const left_selectors = custom_variant_content?.querySelectorAll(".left-eye-variant-selector select[data-type='option']");
    const right_krzywizna = custom_variant_content?.querySelector(".right-eye-variant-selector select[data-type='krzywizna']");
    const left_krzywizna = custom_variant_content?.querySelector(".left-eye-variant-selector select[data-type='krzywizna']");
    const right_srednica = custom_variant_content?.querySelector(".right-eye-variant-selector select[data-type='srednica']");
    const left_srednica = custom_variant_content?.querySelector(".left-eye-variant-selector select[data-type='srednica']");
    const right_axis = custom_variant_content?.querySelector(".right-eye-variant-selector select[data-type='axis']");
    const left_axis = custom_variant_content?.querySelector(".left-eye-variant-selector select[data-type='axis']");
    const right_cylinder = custom_variant_content?.querySelector(".right-eye-variant-selector select[data-type='cylinder']");
    const left_cylinder = custom_variant_content?.querySelector(".left-eye-variant-selector select[data-type='cylinder']");
    const right_input = document.querySelector('#right-variant-id');
    const left_input = document.querySelector("#left-variant-id");
    const is_both = document.querySelector("#is-both");
    const availability_element = document.querySelector("#custom-availability-value");
    const right_quantity_element = custom_variant_content?.querySelector(".right-eye-variant-selector select[data-type='quantity']");
    const left_quantity_element = custom_variant_content?.querySelector(".left-eye-variant-selector select[data-type='quantity']");

    let right_values = {};
    let left_values = {};
    let right_availability = "";
    let left_availability = "";
    let right_selected_variant = null;
    let left_selected_variant = null;

    const METAFIELD_KEYS = ['axis', 'cylinder', 'krzywizna', 'srednica'];

    const normalize = (value) => String(value ?? '').trim();
    const isVariantAvailable = (variant) => Boolean(variant?.available);

    const getMetafieldSelectors = (side) => ({
        axis: side === 'right' ? right_axis : left_axis,
        cylinder: side === 'right' ? right_cylinder : left_cylinder,
        krzywizna: side === 'right' ? right_krzywizna : left_krzywizna,
        srednica: side === 'right' ? right_srednica : left_srednica
    });

    // Only metafields that exist as dropdowns on this PDP
    const getActiveMetafieldKeys = (metafieldSelectors) =>
        METAFIELD_KEYS.filter((key) => Boolean(metafieldSelectors[key]));

    // Product matches when EVERY active metafield equals the selected value
    const productMatchesMetafields = (productData, values, activeKeys) => {
        if (!productData || !activeKeys.length) return false;
        return activeKeys.every((key) => normalize(productData[key]) === normalize(values[key]));
    };

    const findProductByMetafields = (values, activeKeys) => {
        return products.find((p) => productMatchesMetafields(p, values, activeKeys)) || null;
    };

    /**
     * Resolve the exact same_products item for current metafield selections.
     * 1) Exact match on all active metafields
     * 2) If user changed one metafield to an invalid combo, keep that value and
     *    sync the other metafields from the best matching sibling
     */
    const resolveMatchedProduct = (values, activeKeys, metafieldSelectors, changedKey = null) => {
        let matched = findProductByMetafields(values, activeKeys);
        if (matched) return matched;

        if (changedKey && normalize(values[changedKey])) {
            const candidates = products.filter((p) =>
                normalize(p[changedKey]) === normalize(values[changedKey])
            );

            if (candidates.length) {
                candidates.sort((a, b) => {
                    const score = (p) => activeKeys.filter((key) =>
                        key !== changedKey && normalize(p[key]) === normalize(values[key])
                    ).length;
                    return score(b) - score(a);
                });

                matched = candidates[0];

                // Keep the field the user just changed; align the rest to this product
                activeKeys.forEach((key) => {
                    if (key === changedKey) return;
                    values[key] = normalize(matched[key]);
                    if (metafieldSelectors[key]) {
                        metafieldSelectors[key].value = values[key];
                    }
                });

                return matched;
            }
        }

        return null;
    };

    // Variant on the matched product: option1/2/3 must all match
    const findVariantOnProduct = (productData, values) => {
        if (!productData?.variants) return null;

        return productData.variants.find((variant) => {
            const optionCount = [1, 2, 3].filter((i) => values[`option${i}`]).length || 1;
            for (let i = 1; i <= optionCount; i++) {
                const key = `option${i}`;
                if (!values[key]) continue;
                if (normalize(variant[key]) !== normalize(values[key])) return false;
            }
            return true;
        }) || null;
    };

    const getUniqueMetafieldValues = (fieldKey) => {
        const uniqueValues = new Set();
        products.forEach((p) => {
            const value = normalize(p[fieldKey]);
            if (value) uniqueValues.add(value);
        });
        return Array.from(uniqueValues).sort((a, b) =>
            a.localeCompare(b, undefined, { numeric: true })
        );
    };

    // All Shopify option values across the whole same_products family (Moc, Addycja, ...)
    const getUniqueOptionValues = (optionPosition) => {
        const uniqueValues = new Set();
        const optionKey = `option${optionPosition}`;
        products.forEach((p) => {
            (p.variants || []).forEach((variant) => {
                const value = normalize(variant[optionKey]);
                if (value) uniqueValues.add(value);
            });
        });
        return Array.from(uniqueValues).sort((a, b) =>
            a.localeCompare(b, undefined, { numeric: true })
        );
    };

    const populateMetafieldSelector = (selector, fieldKey) => {
        if (!selector) return;
        const uniqueValues = getUniqueMetafieldValues(fieldKey);
        if (!uniqueValues.length) return;

        const previousValue = selector.value;
        selector.innerHTML = '';
        uniqueValues.forEach((value) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = value;
            selector.appendChild(option);
        });
        selector.value = uniqueValues.includes(previousValue) ? previousValue : uniqueValues[0];
    };

    const populateAllMetafieldSelectors = () => {
        [
            [right_axis, 'axis'],
            [left_axis, 'axis'],
            [right_cylinder, 'cylinder'],
            [left_cylinder, 'cylinder'],
            [right_krzywizna, 'krzywizna'],
            [left_krzywizna, 'krzywizna'],
            [right_srednica, 'srednica'],
            [left_srednica, 'srednica']
        ].forEach(([selector, key]) => populateMetafieldSelector(selector, key));
    };

    // Keep every metafield value visible — do not hide based on other selections
    const resetMetafieldSelectorVisibility = (selector) => {
        if (!selector) return;
        Array.from(selector.options).forEach((option) => {
            option.disabled = false;
            option.hidden = false;
        });
    };

    // Rebuild Moc / Addycja from ALL same_products (full lists), keep all options visible
    const rebuildOptionSelectors = (selectors, productData, values) => {
        if (!selectors?.length) return;

        selectors.forEach((selector, index) => {
            const option_position = index + 1;
            const optionKey = `option${option_position}`;
            const sorted = getUniqueOptionValues(option_position);
            if (!sorted.length) return;

            const previousValue = values[optionKey] || selector.value;
            selector.innerHTML = '';
            sorted.forEach((value) => {
                const option = document.createElement('option');
                option.value = value;
                option.textContent = value;
                option.disabled = false;
                option.hidden = false;
                selector.appendChild(option);
            });

            if (sorted.includes(previousValue)) {
                selector.value = previousValue;
                values[optionKey] = previousValue;
            } else {
                selector.value = sorted[0];
                values[optionKey] = sorted[0];
            }
        });

        // If matched product exists, prefer option values that exist on it (still keep all visible)
        if (!productData?.variants) return;

        selectors.forEach((selector, index) => {
            const option_position = index + 1;
            const optionKey = `option${option_position}`;
            const onProduct = new Set(
                productData.variants
                    .map((v) => normalize(v[optionKey]))
                    .filter(Boolean)
            );

            if (onProduct.size && !onProduct.has(normalize(selector.value))) {
                const firstOnProduct = Array.from(onProduct)[0];
                if (firstOnProduct) {
                    selector.value = firstOnProduct;
                    values[optionKey] = firstOnProduct;
                }
            }
        });
    };

    const readCurrentValuesFromDom = (side, values) => {
        const selectors = side === 'right' ? right_selectors : left_selectors;
        const metafieldSelectors = getMetafieldSelectors(side);

        if (selectors) {
            selectors.forEach((selector, index) => {
                values[`option${index + 1}`] = selector.value;
            });
        }

        METAFIELD_KEYS.forEach((key) => {
            if (metafieldSelectors[key]) {
                values[key] = metafieldSelectors[key].value;
            }
        });
    };

    const updateOptionAvailability = (side, changedKey = null) => {
        const selectors = side === 'right' ? right_selectors : left_selectors;
        const values = side === 'right' ? right_values : left_values;
        const metafieldSelectors = getMetafieldSelectors(side);
        const activeKeys = getActiveMetafieldKeys(metafieldSelectors);

        readCurrentValuesFromDom(side, values);

        // 1) Match product by exact metafield values
        const matchedProduct = resolveMatchedProduct(values, activeKeys, metafieldSelectors, changedKey);

        // 2) Always show full metafield lists
        activeKeys.forEach((key) => {
            resetMetafieldSelectorVisibility(metafieldSelectors[key]);
        });

        readCurrentValuesFromDom(side, values);
        const finalProduct = findProductByMetafields(values, activeKeys) || matchedProduct;

        // 3) Always show full Moc / Addycja lists from the family
        rebuildOptionSelectors(selectors, finalProduct, values);

        console.log('Matched product by metafields:', {
            metafields: Object.fromEntries(activeKeys.map((k) => [k, values[k]])),
            product_url: finalProduct?.product_url || null,
            options: {
                option1: values.option1,
                option2: values.option2,
                option3: values.option3
            },
            option_lists: {
                option1: getUniqueOptionValues(1),
                option2: getUniqueOptionValues(2),
                option3: getUniqueOptionValues(3)
            }
        });

        return finalProduct;
    };

    const findMatchingVariant = (values, side) => {
        const metafieldSelectors = getMetafieldSelectors(side);
        const activeKeys = getActiveMetafieldKeys(metafieldSelectors);
        const matchedProduct = findProductByMetafields(values, activeKeys);
        if (!matchedProduct) return null;
        return findVariantOnProduct(matchedProduct, values);
    };

    const updateQuantitySelector = (variant, quantity_selector) => {
        if (!variant || !quantity_selector) return;

        const stock = Number(variant.inventory_quantity);
        const maxQuantity = stock > 0 ? Math.min(stock, 10) : (variant.available ? 10 : 0);
        const currentValue = parseInt(quantity_selector.value, 10) || 1;

        quantity_selector.innerHTML = '';

        for (let i = 1; i <= maxQuantity; i++) {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = i;
            if (i === Math.min(currentValue, maxQuantity)) option.selected = true;
            quantity_selector.appendChild(option);
        }

        if (maxQuantity === 0) {
            const option = document.createElement('option');
            option.value = 0;
            option.textContent = 'Niedostępne';
            option.disabled = true;
            option.selected = true;
            quantity_selector.appendChild(option);
        }
    };

    const change_into_hours = (value) => {
        if (typeof value !== "string") return 0;
        const lowerValue = value.toLowerCase();
        if (lowerValue.includes('day') || lowerValue.includes('dni') || lowerValue.includes('dzień')) {
            return parseInt(value, 10) * 24;
        }
        return parseInt(value, 10) || 0;
    };

    const updateAvailabilityDisplay = () => {
        if (!availability_element) return;

        const rightHours = change_into_hours(right_availability);
        const leftHours = change_into_hours(left_availability);

        if (rightHours > leftHours) {
            availability_element.innerHTML = right_availability;
        } else if (leftHours > rightHours) {
            availability_element.innerHTML = left_availability;
        } else {
            availability_element.innerHTML = right_availability || left_availability || '';
        }
    };

    const selectVariant = (values, side) => {
        const variant = findMatchingVariant(values, side);
        const input = side === 'right' ? right_input : left_input;
        const quantity_selector = side === 'right' ? right_quantity_element : left_quantity_element;

        if (variant && input) {
            input.value = variant.variant_id;

            if (side === 'right') {
                right_selected_variant = variant;
                right_availability = variant.variant_availability;
            } else {
                left_selected_variant = variant;
                left_availability = variant.variant_availability;
            }

            updateQuantitySelector(variant, quantity_selector);
            console.log(`Selected ${side} variant:`, variant, values);
        } else {
            console.warn(`No matching variant for ${side} eye:`, values);
            if (input) input.value = '';
            if (side === 'right') right_selected_variant = null;
            else left_selected_variant = null;
        }

        updateAvailabilityDisplay();
    };

    const bindMetafieldSelector = (selector, fieldKey, values, side) => {
        if (!selector) return;
        values[fieldKey] = selector.value;
        selector.addEventListener("change", () => {
            values[fieldKey] = selector.value;
            updateOptionAvailability(side, fieldKey);
            selectVariant(values, side);
        });
    };

    const initializeSelector = (selectors, side) => {
        const values = side === 'right' ? right_values : left_values;
        const metafieldSelectors = getMetafieldSelectors(side);

        if (selectors) {
            selectors.forEach((selector, index) => {
                const option_position = index + 1;
                values[`option${option_position}`] = selector.value;

                selector.addEventListener("change", () => {
                    values[`option${option_position}`] = selector.value;
                    updateOptionAvailability(side);
                    selectVariant(values, side);
                });
            });
        }

        METAFIELD_KEYS.forEach((key) => {
            bindMetafieldSelector(metafieldSelectors[key], key, values, side);
        });

        updateOptionAvailability(side);
        selectVariant(values, side);
    };

    populateAllMetafieldSelectors();
    console.log('Axis values:', getUniqueMetafieldValues('axis'));
    console.log('Cylinder values:', getUniqueMetafieldValues('cylinder'));

    initializeSelector(right_selectors, 'right');
    initializeSelector(left_selectors, 'left');

    if (is_both) {
        is_both.addEventListener("change", () => {
            if (!is_both.checked) return;

            Object.assign(left_values, right_values);

            if (left_selectors && right_selectors) {
                left_selectors.forEach((leftSelector, index) => {
                    if (right_selectors[index]) leftSelector.value = right_selectors[index].value;
                });
            }

            if (left_axis && right_axis) left_axis.value = right_axis.value;
            if (left_cylinder && right_cylinder) left_cylinder.value = right_cylinder.value;
            if (left_krzywizna && right_krzywizna) left_krzywizna.value = right_krzywizna.value;
            if (left_srednica && right_srednica) left_srednica.value = right_srednica.value;

            updateOptionAvailability('left');
            selectVariant(left_values, 'left');
        });
    }

    const add_to_cart_btn = document.querySelector("buy-button .product-form__add-button");
    if (add_to_cart_btn) {
        add_to_cart_btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const right_quantity = parseInt(right_quantity_element?.value, 10) || 0;
            const left_quantity = parseInt(left_quantity_element?.value, 10) || 0;
            const right_variant_id = right_input?.value;
            const left_variant_id = left_input?.value;

            if (!right_variant_id) {
                alert('Proszę wybrać wariant dla prawego oka.');
                return;
            }

            if (!is_both.checked && !left_variant_id) {
                alert('Proszę wybrać wariant dla lewego oka.');
                return;
            }

            if (right_quantity <= 0 || (right_selected_variant && right_selected_variant.inventory_quantity > 0 && right_quantity > right_selected_variant.inventory_quantity)) {
                alert('Nieprawidłowa ilość dla prawego oka.');
                return;
            }

            if (!is_both.checked && (left_quantity <= 0 || (left_selected_variant && left_selected_variant.inventory_quantity > 0 && left_quantity > left_selected_variant.inventory_quantity))) {
                alert('Nieprawidłowa ilość dla lewego oka.');
                return;
            }

            const data = {
                items: [
                    {
                        id: right_variant_id,
                        quantity: right_quantity,
                        properties: { Oko: "Prawe" }
                    }
                ]
            };

            if (!is_both.checked) {
                data.items.push({
                    id: left_variant_id,
                    quantity: left_quantity,
                    properties: { Oko: "Lewe" }
                });
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
                .then((response) => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then((result) => {
                    console.log('Successfully added to cart:', result);
                    document.documentElement.dispatchEvent(new CustomEvent("product:added", {
                        bubbles: true,
                        detail: {
                            button: e.target,
                            variant: null,
                            quantity: is_both.checked ? right_quantity : (right_quantity + left_quantity),
                            productAdded: true
                        }
                    }));
                })
                .catch((error) => {
                    console.error('Error adding to cart:', error);
                    alert('Nie można dodać większej ilości – ograniczona dostępność produktu');
                });
        });
    }
});
